import axiosInstance from './AxiosInstance';

/**
 * Obtiene el resumen del dashboard (empresas, usuarios, vacantes)
 * GET /api/dashboard/resumen
 */
export function getDashboardResumen() {
    return axiosInstance.get('/dashboard/resumen');
}
